import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { currencyFormatter } from 'utils/formatter';
import moment from 'moment';
import _ from 'lodash';

import {
  cancelReactivateOutlet,
  confirmReactivateOutlet,
} from 'actions/outletPages/list';
import styles from './ConfirmReactivateOutletModal.css';

class ConfirmReactivateOutletModal extends React.Component {
  render() {
    const {
      showConfirmReactivateOutletModal,
      reactivatedOutlet,
      outletPrice,
      payButtonMessage,
      disablePayButton,
      pendingPaymentMessage,
      onLoadingPayButton,
      isEnterprise,
    } = this.props;
    return (
      <Modal
        onHide={this._onHide}
        show={showConfirmReactivateOutletModal}
        dialogClassName={`${
          styles['reactivate-outlet-modal-wrapper']
        } modal-dialog`}
      >
        <Modal.Body bsClass={styles['modal-wrapper']}>
          <div className="reactivate-outlet-modal-wrapper">
            <button
              type="button"
              className="close"
              onClick={() => {
                this._onHide();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4>Reactivate Outlet</h4>
            <hr />
            <div className="row" style={{ verticalAlign: 'middle' }}>
              <div className="col-xs-7">
                <strong>
                  {reactivatedOutlet && (
                    <span style={{ lineHeight: '34px' }}>
                      {reactivatedOutlet.name}
                    </span>
                  )}
                </strong>
              </div>
              <div className="col-xs-5">
                {!isEnterprise && outletPrice.MOKA && (
                  <div>
                    <div>
                      <span className={styles['pricing-text']}>
                        {currencyFormatter(outletPrice.MOKA.final_price)}
                      </span>
                    </div>
                    <div>
                      <span className={styles['pro-rated-period-text']}>
                        pro-rated for period from <br />
                        {moment().format('DD/MM/YYYY')} -{' '}
                        {moment(outletPrice.MOKA.end_date).format('DD/MM/YYYY')}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {!isEnterprise &&
              outletPrice &&
              _.map(outletPrice, (featureDetail, featureName) => {
                if (
                  featureName !== 'MOKA' &&
                  featureName !== 'final_price' &&
                  featureDetail.total_price !== 0
                ) {
                  return (
                    <div
                      className={`row ${styles['outlet-features']}`}
                      style={{ verticalAlign: 'middle' }}
                    >
                      <div className="col-xs-4">
                        <span style={{ lineHeight: '34px' }}>
                          {featureName}
                        </span>
                      </div>
                      <div className="col-sm-2 col-xs-4" />
                      <div className="col-xs-1" />
                      <div className="col-xs-5">
                        <div>
                          <span className={styles['pricing-text']}>
                            {currencyFormatter(
                              outletPrice[featureName].final_price
                            )}
                          </span>
                        </div>
                        <div>
                          <span className={styles['pro-rated-period-text']}>
                            pro-rated for period from <br />
                            {moment().format('DD/MM/YYYY')} -{' '}
                            {moment(outletPrice[featureName].end_date).format(
                              'DD/MM/YYYY'
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                }
              })}
            <hr />
            <div className="row text-primary">
              <div className={`${isEnterprise ? 'col-xs-5' : 'col-xs-7'}`}>
                <h3>Total Payment</h3>
              </div>
              <div className={`${isEnterprise ? 'col-xs-7' : 'col-xs-5'}`}>
                {!isEnterprise && outletPrice && (
                  <h3 className="totalCount">
                    {currencyFormatter(
                      (outletPrice.final_price * 1).toString()
                    )}
                  </h3>
                )}
                {isEnterprise && (
                  <div className={`${styles['is-enterprise']}`}>
                    <p>
                      For more details on your bill, please contact your sales
                      representative or contact customer support at 1500970
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            {!isEnterprise && (
              <div className={`row ${styles['pay-button-wrapper']}`}>
                <div className="col-xs-12">
                  <button
                    id="pay-reactivate-outlet-button"
                    className={`btn btn-block btn-lg ${
                      disablePayButton ? 'btn-disabled' : 'btn-primary'
                    } ${onLoadingPayButton ? styles['on-loading-button'] : ''}`}
                    onClick={() => this._onConfirm()}
                    disabled={disablePayButton}
                  >
                    {payButtonMessage}
                  </button>
                </div>
              </div>
            )}
            {!isEnterprise && pendingPaymentMessage && (
              <div
                className={`row ${styles['pending-message']} ${
                  styles['text-xs']
                }`}
              >
                <div className="col-md-12">
                  <em>{pendingPaymentMessage}</em>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  _onHide = () => {
    const { dispatch } = this.props;
    dispatch(cancelReactivateOutlet());
  };

  _onConfirm = () => {
    const { reactivatedOutlet, dispatch, outletPrice } = this.props;
    const billingData = {
      type: 'OutletBilling',
      total_amount: outletPrice.final_price,
      add_outlet_count: 1,
      outlet: reactivatedOutlet,
    };
    dispatch(confirmReactivateOutlet(billingData));
  };
}

ConfirmReactivateOutletModal.propTypes = {
  showConfirmReactivateOutletModal: PropTypes.bool,
  reactivatedOutlet: PropTypes.object,
  dispatch: PropTypes.func,
  outlets: PropTypes.array,
};

function mapStateToProps(state) {
  const {
    business: { is_enterprise },
  } = state.moka.user;
  const {
    showConfirmReactivateOutletModal,
    reactivatedOutlet,
    outlets,
    outletPrice,
    payButtonMessage,
    disablePayButton,
    pendingPaymentMessage,
    onLoadingPayButton,
  } = state.outletPages.list;
  return {
    showConfirmReactivateOutletModal,
    reactivatedOutlet,
    outlets,
    outletPrice,
    payButtonMessage,
    disablePayButton,
    pendingPaymentMessage,
    onLoadingPayButton,
    isEnterprise: is_enterprise,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmReactivateOutletModal);
